import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LoadContainers_ds_get_pick_tasks_by_orderIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { order_ids: number[], taskStatus?: number[] }): 
  Promise<{ result: { Id?: number, ActualTargetLicensePlateId?: number, OrderId?: number, Order?: { LookupCode?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string, Location?: { Id?: number, ParentLocationContainer?: { Id?: number, Name?: string } } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_ids)) {
      missingRequiredInParams.push('\'order_ids\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_pick_tasks_by_orderIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { order_ids: number[], taskStatus?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualTargetLicensePlateId?: number, OrderId?: number, Order?: { LookupCode?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string, Location?: { Id?: number, ParentLocationContainer?: { Id?: number, Name?: string } } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_ids)) {
      missingRequiredInParams.push('\'order_ids\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_pick_tasks_by_orderIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { order_ids: number[], taskStatus?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualTargetLicensePlateId?: number, OrderId?: number, Order?: { LookupCode?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string, Location?: { Id?: number, ParentLocationContainer?: { Id?: number, Name?: string } } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_ids)) {
      missingRequiredInParams.push('\'order_ids\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_pick_tasks_by_orderIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      order_ids: number[], taskStatus?: number[]    }) {
        if(isNil(inParams.order_ids)) {
          return true; 
        }
      return false;
    }
}
